import script from "./customerCase.vue?vue&type=script&setup=true&lang=js"
export * from "./customerCase.vue?vue&type=script&setup=true&lang=js"

import "./customerCase.vue?vue&type=style&index=0&id=76e3f85c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e3f85c"]])

export default __exports__